package shared.utils

import kotlin.js.Date

/**
 * Utility functions for time formatting
 */
object TimeUtils {
    /**
     * Format ISO timestamp to relative time string
     * @param isoTimestamp ISO 8601 timestamp string
     * @return Relative time string (e.g., "2 hours ago", "Yesterday")
     */
    fun formatRelativeTime(isoTimestamp: String): String {
        if (isoTimestamp.isEmpty()) return ""
        
        return try {
            val timestamp = Date(isoTimestamp)
            val now = Date()
            val diffMs = now.getTime() - timestamp.getTime()
            val diffMinutes = (diffMs / 60000).toInt()
            val diffHours = (diffMs / 3600000).toInt()
            val diffDays = (diffMs / 86400000).toInt()
            
            when {
                diffMinutes < 1 -> "Just now"
                diffMinutes < 60 -> "$diffMinutes minute${if (diffMinutes != 1) "s" else ""} ago"
                diffHours < 24 -> "$diffHours hour${if (diffHours != 1) "s" else ""} ago"
                diffDays == 1 -> "Yesterday"
                diffDays < 7 -> "$diffDays day${if (diffDays != 1) "s" else ""} ago"
                else -> {
                    // Format as "MMM DD"
                    val months = arrayOf("Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                                        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec")
                    val month = months[timestamp.getMonth()]
                    val day = timestamp.getDate()
                    "$month $day"
                }
            }
        } catch (e: Throwable) {
            console.error("Error formatting timestamp:", e)
            ""
        }
    }
}
